module.exports = __webpack_public_path__ + "img/dba6571.jpg";